export var ActionType;
(function (ActionType) {
    ActionType["GetImage"] = "GET_IMAGE";
    ActionType["UploadImage"] = "UPLOAD_IMAGE";
})(ActionType || (ActionType = {}));
//# sourceMappingURL=providers.js.map